import {styled} from 'styled-components';
import {Route} from 'wouter';

import {BrowsePage} from '@src/components/browse_page';
import {CreateProjectPage} from '@src/components/create_project_page';
import {HomePage} from '@src/components/home_page';
import {ProjectPage} from '@src/components/project_page';
import {ProjectScorePage} from '@src/components/project_score_page';
import {Palette} from '@src/theme';

export const App: React.FC = () => {
  return (
    <Route path="/" nest>
      <Wrapper>
        <Route path="/" component={HomePage} />
        <Route path="/create-project" component={CreateProjectPage} />
        <Route path="/browse" component={BrowsePage} />
        <Route path="/browse/:key" component={BrowsePage} />
        <Route path="/project/:id" component={ProjectPage} />
        <Route path="/project/:id/score" component={ProjectScorePage} />
        <Route path="/project/:id/score/:key" component={ProjectScorePage} />
      </Wrapper>
    </Route>
  );
};
App.displayName = 'App';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: ${Palette.background1};
  background: ${Palette.background2};
`;
